import SiteLogo from '@/components/Logo'
import { localizeHref } from '@/i18n/href'
import { pdfLinkProps } from '@/lib/pdf'
import { useI18n } from '@/i18n/I18nProvider'
import type { SectionOf } from './shared'

export default function LogosSection({ section }: { section: SectionOf<'logos'> }) {
  const { locale } = useI18n()
  return (
    <div className="text-center">
      {section.heading && (
        <h2 className="text-3xl font-bold tracking-tight sm:text-4xl">{section.heading}</h2>
      )}
      {section.sub && <p className="mt-4 text-lg text-muted-foreground">{section.sub}</p>}
      {section.items?.length ? (
        // One shared width with a height ceiling, and `object-contain`: these
        // marks range from a square icon to a wordmark six times as wide, and
        // what a reader compares across a row is how far a mark reaches, not
        // how much ink it holds. `Logo.tsx` carries the measure.
        <ul className="mx-auto mt-12 grid max-w-5xl grid-cols-2 items-center justify-items-center gap-x-8 gap-y-10 sm:grid-cols-3 lg:grid-cols-4">
          {section.items.map((item) => (
            // `h-20`: the tallest step a mark can take is 64px (see `Logo.tsx`),
            // and a row shorter than its own cap would let that mark hang into
            // the gutter instead of sitting on the same baseline as its
            // neighbours. The extra 16px is the air a 64px mark needs to sit in
            // a row rather than fill it.
            //
            // Greyscale, the same as the customer wall on `/en/customers`: these
            // are the same marks making the same claim, so one brand's red
            // beside a set of grey ones is the same shouting the shared width
            // measure exists to stop.
            <li key={item.src} className="flex h-20 items-center grayscale">

              <SiteLogo logo={item} />
            </li>
          ))}
        </ul>
      ) : null}
      {section.cta && (
        <a
          href={localizeHref(section.cta.href, locale)}
          {...pdfLinkProps(section.cta.href)}
          className="btn-primary mt-10 inline-flex"
        >
          {section.cta.label}
        </a>
      )}
    </div>
  )
}
